export default __webpack_public_path__ + "static/media/304.83a80806.svg";